import { SharedModule } from '@/app/shared/shared.module';
import { Component, input, OnInit, output } from '@angular/core';

@Component({
  selector: 'app-sustainability-dashboard-empty-contracts',
  imports: [SharedModule],
  templateUrl: './sustainability-dashboard-empty-contracts.component.html',
  styleUrl: './sustainability-dashboard-empty-contracts.component.less',
})
export class SustainabilityDashboardEmptyContractsComponent {
  readonly wasThereError = input(false);

  readonly tryAgainEvent = output<void>();
}
